import Vue from "vue";
import { findInFormAnswer } from "./find_in_form_answer.js";

export class CheckboxFormInput {
  constructor() {
    this.type = "checkbox";
    this.data = {
      required: false,
      question: "",
      answers: [{ text: "" }, { text: "" }, { text: "" }],
    };
  }
}

export let CheckboxFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#checkbox-form-input-template",
  data: function () {
    return {
      trainee_answer: [],
    };
  },
  methods: {
    deleteAnswer: onDeleteAnswer,
    addAnswer: onAddAnswer,
    toggleAnswer: toggleAnswer,
  },
  created: function () {
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
    }
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});

function onAddAnswer() {
  this.input.data.answers.push({ text: "" });
}

function onDeleteAnswer(index) {
  this.input.data.answers.splice(index, 1);
}

function toggleAnswer(index) {
  if (this.trainee_answer.includes(index)) {
    this.trainee_answer.splice(this.trainee_answer.indexOf(index), 1);
  } else {
    this.trainee_answer.push(index);
  }
}
